import { useState } from 'react';

export function useSince(ms: number) {
  const [since] = useState(() => new Date(Date.now() - ms).toISOString());

  return since;
}

export function useSinceDays(days: number) {
  return useSince(days * 24 * 60 * 60 * 1000);
}

export function useStartOfTodayUtc() {
  const [start] = useState(() => {
    const now = new Date();

    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())).toISOString();
  });

  return start;
}
